import {
    defineAsyncComponent,
    defineComponent,
    FunctionalComponent,
    RenderFunction,
    SetupContext,
    Slot,
    SlotsType,
} from "vue";
import { renderSingle } from "@/components/render-transformer";

const PromiseResolverInner: FunctionalComponent<
    {},
    {},
    {
        default: () => Slot<[]>;
    }
> = ({}, { slots }) => {
    return renderSingle(slots.default);
};

export const useAsyncDependency = (resolver: () => Promise<void>) =>
    defineAsyncComponent(async () => {
        await resolver().catch((e) => {
            console.error(e);
            throw e;
        });
        return PromiseResolverInner;
    });

export const useAsyncResolver = (resolver: () => Promise<void>) =>
    defineComponent(
        async (
            {},
            { slots }: SetupContext<{}, SlotsType<{ default: Slot<[]> }>>,
        ): Promise<RenderFunction> => {
            await resolver().catch((e) => {
                console.error(e);
                throw e;
            });

            return () => {
                return renderSingle(slots.default);
            };
        },
        {
            name: "AsyncResolver",
            slots: Object as SlotsType<{
                default: Slot;
            }>,
        },
    );
